<script>
    import modals from '../state/modals';
    import user from '../state/user';

    import SignIn from './sign/sign-in.svelte';
    import SignUp from './sign/sign-up.svelte';

    let openTab = 'sign-in';
    let email = '';

    let isSignInOpen, isSignUpOpen = false;
    $: isSignInOpen = (openTab == 'sign-in');
    $: isSignUpOpen = (openTab == 'sign-up');

    function closeModal(e) {
        modals.toggleSignModal(false);
    }

    function switchTab(e) {
        const { detail } = e;

        let validTabs = [ 'sign-in', 'sign-up' ];

        if (typeof detail === 'object' && typeof detail.tab === 'string') {
            for (let prop in detail) {
                if (!detail.hasOwnProperty(prop)) continue;

                const val = detail[prop];

                if (prop === 'tab') {
                    openTab = val;
                } else if (prop === 'email') {
                    email = val;
                }
            }
        } else if (typeof detail === 'string' && validTabs.indexOf(detail) >= 0) {
            openTab = detail;
        }
    }
</script>

<style>
    .modal-card-foot { padding: 38px 20px; }
</style>

{#if $modals.sign_opened}
    <div class="modal" class:is-active={$modals.sign_opened}>
        <div class="modal-background" on:click={closeModal}></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <div class="modal-card-title">
                    <div class="tabs is-toggle is-centered">
                        <ul>
                            <li class:is-active={isSignInOpen}>
                                <a href="#sign-in" on:click|preventDefault={() => openTab = 'sign-in'}>Přihlášení</a>
                            </li>
                            <li class:is-active={isSignUpOpen}>
                                <a href="#sign-up" on:click|preventDefault={() => openTab = 'sign-up'}>Registrace</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <button class="delete" aria-label="Zavřít" on:click={closeModal}></button>
            </header>
            <section class="modal-card-body">
                {#if isSignInOpen}
                    <div class="tab">
                        <SignIn bind:email on:close={closeModal} />
                    </div>
                {/if}

                {#if isSignUpOpen}
                    <div class="tab">
                        <SignUp bind:email on:close={closeModal} on:switch={switchTab} />
                    </div>
                {/if}
            </section>

            <footer class="modal-card-foot"></footer>
        </div>
    </div>
{/if}